import { render, staticRenderFns } from "./status-form-auth.vue?vue&type=template&id=0bb4d2a1&scoped=true"
import script from "./status-form-auth.vue?vue&type=script&lang=js"
export * from "./status-form-auth.vue?vue&type=script&lang=js"
import style0 from "./status-form-auth.vue?vue&type=style&index=0&id=0bb4d2a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4d2a1",
  null
  
)

export default component.exports